export default "__VITE_ASSET__6b7e9887__"